import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggleFeature(event) {
    // Visual feedback — no immediate save, wait for Save button
    const checkbox = event.target
    if (checkbox.checked) {
      checkbox.classList.add('border-success')
    } else {
      checkbox.classList.remove('border-success')
    }
  }

  async savePlan(event) {
    const planId = event.params.planId
    const url = event.params.url
    const button = event.target

    // Collect all checked features for this plan
    const checkboxes = this.element.querySelectorAll(`input[type="checkbox"][data-plan-grid-plan-id-param="${planId}"]`)
    const features = []
    checkboxes.forEach(cb => {
      if (cb.checked) {
        features.push(cb.dataset.planGridFeatureParam)
      }
    })

    // Submit via fetch
    button.disabled = true
    button.textContent = 'Saving...'

    try {
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
      const response = await fetch(url, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken,
          'Accept': 'application/json'
        },
        body: JSON.stringify({ plan: { feature_list: features } })
      })

      if (response.ok) {
        button.textContent = 'Saved!'
        button.classList.remove('btn-primary')
        button.classList.add('btn-success')
        setTimeout(() => {
          button.textContent = 'Save'
          button.classList.remove('btn-success')
          button.classList.add('btn-primary')
          button.disabled = false
        }, 2000)
      } else {
        button.textContent = 'Error'
        button.classList.remove('btn-primary')
        button.classList.add('btn-danger')
        setTimeout(() => {
          button.textContent = 'Save'
          button.classList.remove('btn-danger')
          button.classList.add('btn-primary')
          button.disabled = false
        }, 2000)
      }
    } catch (error) {
      button.textContent = 'Error'
      button.disabled = false
    }
  }
}
